import React from 'react';
import { DialogTrigger, Flex } from '@adobe/react-spectrum';
import { usePress } from '@react-aria/interactions';
import Search from '@spectrum-icons/workflow/Search';
import { Minimap } from 'app/views/components/footer/minimap/Minimap';
import { Text } from 'app/views/components/typography/Text';
import { useConnect } from 'app/views/hooks/useConnect';
import { call } from 'app/utils/function';
const ZoomButton = React.forwardRef((props, ref) => {
    const { label, onToggle } = props;
    const { pressProps } = usePress({ onPress: props.onPress });
    const $onToggle = React.useCallback(() => {
        call(onToggle, true);
    }, [onToggle]);
    return (React.createElement("div", Object.assign({ "data-test-id": "zoom-trigger", ref: ref, style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            cursor: 'pointer',
        } }, pressProps, { onPointerDown: $onToggle, onMouseEnter: $onToggle }),
        React.createElement(Search, { size: "XS", marginEnd: "size-50" }),
        React.createElement(Flex, { width: "size-400" },
            React.createElement(Text, { size: "XS" }, label))));
});
export const Zoom = () => {
    const ref = React.useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const { zoom, isAnnotating } = useConnect((state) => {
        const { zoom: zoomFloat } = state.viewport;
        return {
            zoom: Math.trunc(Math.round(zoomFloat * 100)),
            isAnnotating: state.editor.activeController === 'image-annotate',
        };
    });
    const onToggle = React.useCallback((shouldOpen) => setIsOpen(shouldOpen), [setIsOpen]);
    if (!isAnnotating) {
        return null;
    }
    return (React.createElement(DialogTrigger, { type: "popover", placement: "top", hideArrow: true, targetRef: ref, isOpen: isOpen, onOpenChange: shouldBeOpen => shouldBeOpen === false && setIsOpen(false) },
        React.createElement(ZoomButton, { ref: ref, label: `${zoom}%`, onToggle: onToggle }),
        React.createElement(Minimap, null)));
};
